import React, {useState} from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import {Action} from '../../../system/buttons';
import ColorPicker from './ColorPicker';

export const ChristmasWidgetEdit = (props) => {
  const [configuration, setConfiguration] = useState(props.configuration);

  return (
    <>
      <h4>Configured ranges</h4>
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Text Color
        </Form.Label>
        <Col sm="3">
          <ColorPicker
            color={configuration?.color}
            onChangeComplete={(color) => {
              setConfiguration({...configuration, color});
              props.onUpdate({...configuration, color});
            }}
          />
        </Col>
      </Form.Group>
      <Row>&nbsp;</Row>
      <Action onClick={() => props.onSave(configuration)}>Save settings</Action>
    </>
  );
};
